(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-collection-nav"] && !Shopify.designMode) return;
  try {
    
  window.onscroll = function() {
    stickyFunction();
  };

  function stickyFunction() {
    const container = document.getElementById("scrollableContainer");
    const offset = (window.innerWidth <= 768) ? 60 : 120;
    if (window.pageYOffset >= offset) {
      container.classList.add("sticky");
    } else {
      container.classList.remove("sticky");
    }
    const headerCategoriesMenu = document.querySelector('#shopify-section-header-categories-menu');
    const topCollectionNavContainer = document.querySelector('.top-collection-navigation-container');

    if (headerCategoriesMenu && topCollectionNavContainer) {
        if (headerCategoriesMenu.classList.contains('shopify-section-header-hidden')) {
            topCollectionNavContainer.style.top = '0';
        } else {
            topCollectionNavContainer.style.top = '48px';
        }
    }
  }


  } catch(e) { console.error(e); }
})();
})();
